import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../../../Services/api.service';
import { WorkflowModel } from 'src/app/shared/workflow/workflow.models';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-citationworkflows',
    templateUrl: './citationworkflows.component.html',
    styleUrls: ['./citationworkflows.component.scss'],
    standalone: false
})
export class CitationWorkflowsComponent implements OnInit {
  public workflow: WorkflowModel | null = null;
  public isLoading = false;

  constructor(private api: ApiService, private toastr: ToastrService) {}

  async ngOnInit(): Promise<void> {
    this.isLoading = true;
    try {
      const response = await this.api.Get<any>('workflows/default/Citation');
      this.workflow = this.mapResponse(response);
    } catch (error) {
      console.error('Unable to load citation workflow', error);
      this.toastr.error('Unable to load citation workflow.');
    } finally {
      this.isLoading = false;
    }
  }

  private mapResponse(response: any): WorkflowModel {
    const states = (response?.States || []).map((state: any) => ({
      Id: state.Id ?? null,
      StateKey: state.StateKey,
      Name: state.Name,
      Description: state.Description,
      IsInitial: !!state.IsInitial,
      IsFinal: !!state.IsFinal,
      IsActive: !!state.IsActive
    }));

    const transitions = (response?.Transitions || []).map((transition: any) => ({
      Id: transition.Id ?? null,
      FromStateKey: transition.FromStateKey,
      ToStateKey: transition.ToStateKey,
      Name: transition.Name,
      Description: transition.Description,
      IsManualTrigger: !!transition.IsManualTrigger,
      IsAutomaticTrigger: !!transition.IsAutomaticTrigger,
      MinimumTimeInSourceState: transition.MinimumTimeInSourceState ?? 0,
      Priority: transition.Priority ?? 1,
      Conditions: (transition.Conditions || transition.ConditionEntities || []).map((c: any) => ({
        Id: c.Id ?? null,
        PropertyName: c.PropertyName,
        Operator: c.Operator,
        Value: c.Value,
        ExecutionOrder: c.ExecutionOrder ?? 1
      }))
    }));

    return {
      Id: response?.Id ?? 0,
      TargetType: response?.TargetType ?? 'Citation',
      Name: response?.Name ?? 'Citation Workflow',
      Description: response?.Description,
      IsActive: response?.IsActive ?? true,
      IsDefault: response?.IsDefault ?? true,
      States: states,
      Transitions: transitions
    };
  }
}
